Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="text-muted text-center">' +
((__t = ( ctx.t(ctx.component.title) )) == null ? '' : __t) +
'</div>\n';
return __p
}